import { render, staticRenderFns } from "./MenuReports.vue?vue&type=template&id=48232c14"
import script from "./MenuReports.vue?vue&type=script&lang=js"
export * from "./MenuReports.vue?vue&type=script&lang=js"
import style0 from "./MenuReports.vue?vue&type=style&index=0&id=48232c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports